import { addMonths, format, UTCDate } from '@/utils/dates';

export const generatePayrollMonths = () => {
  const MONTHS_TO_SHOW = 6;
  const months = [];

  const startDate = addMonths(new UTCDate(), -2);

  for (let i = 0; i < MONTHS_TO_SHOW; i++) {
    const date = addMonths(startDate, i);
    const value = format(date, 'MMMM yyyy');
    const shortLabel = format(date, 'MMM yyyy');

    months.push({ key: i, value, label: value, shortLabel });
  }

  return months;
};
